import PoliticaCookies from './PoliticaCookies'
export default PoliticaCookies
